import { Card, CardContent } from '../../../../components/ui/card'
import { Badge } from '../../../../components/ui/badge'
import { Progress } from '../../../../components/ui/progress'
import type { BrandEquityReport } from '../../types'
import { STATUS_COLORS } from '../../types'

interface DBEIHeroProps {
  report: BrandEquityReport
}

export default function DBEIHero({ report }: DBEIHeroProps) {
  const { dbei_score, brand_status, score_change, data_coverage_pct } = report

  const statusColor = STATUS_COLORS[brand_status] || '#6b7280'

  const renderChange = () => {
    if (score_change === null || score_change === undefined) {
      return <span className="text-gray-400 text-sm">N/A</span>
    }
    if (score_change > 0) {
      return (
        <span className="text-green-600 text-sm font-medium">
          ▲ +{score_change.toFixed(2)}
        </span>
      )
    }
    if (score_change < 0) {
      return (
        <span className="text-red-600 text-sm font-medium">
          ▼ {score_change.toFixed(2)}
        </span>
      )
    }
    return <span className="text-gray-400 text-sm">— 0.00</span>
  }

  return (
    <Card>
      <CardContent className="p-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="space-y-1">
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wider">DBEI Score</p>
            <p className="text-3xl font-bold text-[#5C4FCF]">{dbei_score.toFixed(2)}</p>
          </div>

          <div className="space-y-1">
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wider">Brand Status</p>
            <Badge
              className="text-sm font-semibold px-3 py-1"
              style={{ backgroundColor: statusColor, color: '#fff' }}
            >
              {brand_status}
            </Badge>
          </div>

          <div className="space-y-1">
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wider">Score Change</p>
            {renderChange()}
          </div>

          <div className="space-y-1">
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wider">Data Coverage</p>
            <div className="space-y-1">
              <p className="text-sm font-semibold">{data_coverage_pct.toFixed(1)}%</p>
              <Progress value={data_coverage_pct} className="h-2" />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
